import { Ticket } from '@phosphor-icons/react';

export default Ticket;
